/**
 * Service for getting user-data
 */
import helpers from './DataserviceHelpers.js'
import Backend from '../Backend'

/* @ngInject */
class UserData {
  static getFirstName = function(id) {
    const fields = ["U_GivenName"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`/api/TAB_USER/${id}?${fieldlist}`)
      .then(res => {
        if (res.length === 0) {
          return ''
        } else {
          return res[0].U_GivenName;
        }
      });
  }

}

export default UserData;
